import { HomeOfficeExpensePeriod } from "./types";

interface CalculateGrossAmountInputs {
  officeAreaShare: number;
  adjustByOfficeAreaShare: boolean;
  period: HomeOfficeExpensePeriod;
  amount: number;
  monthsUsed: number;
}

type CalculateNetOrVatAmountInputs = CalculateGrossAmountInputs & {
  vatRate: number;
};

export const calculateGrossAmount = ({
  officeAreaShare,
  adjustByOfficeAreaShare,
  period,
  amount,
  monthsUsed,
}: CalculateGrossAmountInputs): number => {
  const share = adjustByOfficeAreaShare ? officeAreaShare : 1;
  let grossAmount = 0;
  switch (period) {
    case HomeOfficeExpensePeriod.MONTHLY:
      grossAmount = Math.floor(amount * monthsUsed * share);
      break;
    case HomeOfficeExpensePeriod.ANNUAL:
      grossAmount = Math.floor((amount * monthsUsed * share) / 12);
      break;
    case HomeOfficeExpensePeriod.ONE_TIME_PAYMENT:
      grossAmount = Math.floor(amount * share);
      break;
    default:
      grossAmount = 0;
  }
  return grossAmount;
};
export const calculateNetAmount = ({
  officeAreaShare,
  adjustByOfficeAreaShare,
  period,
  amount,
  monthsUsed,
  vatRate,
}: CalculateNetOrVatAmountInputs): number => {
  const grossAmount = calculateGrossAmount({
    officeAreaShare,
    adjustByOfficeAreaShare,
    period,
    amount,
    monthsUsed,
  });
  return Math.floor(grossAmount / (1 + vatRate / 100));
};
export const calculateVatAmount = ({
  officeAreaShare,
  adjustByOfficeAreaShare,
  period,
  amount,
  monthsUsed,
  vatRate,
}: CalculateNetOrVatAmountInputs): number => {
  const grossAmount = calculateGrossAmount({
    officeAreaShare,
    adjustByOfficeAreaShare,
    period,
    amount,
    monthsUsed,
  });
  const netAmount = calculateNetAmount({
    officeAreaShare,
    adjustByOfficeAreaShare,
    period,
    amount,
    monthsUsed,
    vatRate,
  });
  return grossAmount - netAmount;
};
